export const GalleryPageContentData = {
  'Save the Date': {
    heading: 'Save the Date',
    bannerEyebrow: 'Send Smarter',
    bannerTitle: 'Save the Dates',
    bannerBody:
      'Design and send printed and free online Save the Dates. Match your wedding website, choose from hundreds of designs, or feature a favorite photo.',
    getStarted: 'Get Started',
    isBannerLink: false,
    bannerWidth: '335px',
    loadMoreButton: 'View All Save the Dates',
    loadMoreButtonLink: '/cards/wedding/save-the-date?scenario=save-the-date',
  },
  Invitation: {
    heading: 'Wedding Invitation',
    bannerEyebrow: 'Send Smarter',
    bannerTitle: 'Wedding Invitations',
    bannerBody:
      'Design and send beautiful printed invitations or free online invitations backed by powerful and personalized RSVP features you won’t find anywhere else.',
    getStarted: 'Get Started',
    isBannerLink: false,
    bannerWidth: '382px',
    loadMoreButton: 'View All Invitations',
    loadMoreButtonLink: '/cards/wedding/invitation?scenario=invitation',
  },
  'Wedding Website': {
    heading: 'Wedding Website',
    bannerEyebrow: 'Free Wedding Website Designs',
    bannerTitle: 'Thousands of design combinations.',
    bannerBody:
      'Create the perfect look. Mix and match layouts, themes, fonts, colors, and photos to design your own wedding website template in minutes. You can change any part of your design at anytime.',
    getStarted: 'Start Customizing Your Website',
    isBannerLink: true,
    bannerWidth: '420px',
    loadMoreButton: 'Load More Designs',
  },
  Prints: {
    heading: '',
    bannerEyebrow: '',
    bannerTitle: '',
    bannerBody: '',
    getStarted: '',
    isBannerLink: true,
    bannerWidth: '',
    loadMoreButton: '',
  },
  notFindingWhatLooking: 'Not finding what you’re looking for?',
  resultsMayMatchOneOrMore: 'Results that match at least one of your selected filters',
  resultsDontMatchAnything: 'More designs',
  letUsKnow: 'Let us know!',
  matchingPrints: 'Matching Prints',
  filter: 'Filter',
  clearAll: 'Clear all',
  tryUsingFewer: 'Try using fewer or remove all filters',
  clearAllFilters: 'Clear All Filters',
  printNOnline: 'Print + Online',
  online: 'Online Only',
} as const;

export const eCardDetailData = {
  startInvitationButton: 'Start with this Invitation',
  startSaveTheDateButton: 'Start with this Save the Date',
  getStarted: 'Get Started',
  startDesignsButton: 'Start with this Design',
  name: 'Name',
  font: 'Font',
  freeOnlineSaveTheDate: 'Free Online Save the Dates',
  freeOnlineInvitation: 'Free Online Invitations',
  freeDesigns: 'Free Wedding Website',
  freePhotoSavetheDates: 'Free Photo Save the Dates',
  matchingPrints: 'Matching Prints by ',
  matchingCards: 'Matching Cards by ',
  customizeFonts: 'Customizeable Font',
  featureAnyPhoto: 'Feature Any Photo',
  poweredBy: 'Connected Guest List',
  rsvpIncludes: 'Smart RSVP Included',
  matchingPrintsVal: 'Matching Prints',
  optimizedMobile: 'Optimized for Mobile',
  layout: 'Layout',
  themeVariants: 'Style',
  singlePage: 'Single Page',
  multiPage: 'Multi-Page',
  viewDemoSite: 'View Demo Site',
} as const;

export const productTypes = {
  designs: 'Wedding Website',
  saveTheDate: 'Save the Date',
  invitation: 'Invitation',
  prints: 'Prints',
} as const;

export const apiProductTypes = {
  'Save the Date': 'savethedate',
  'Wedding Website': 'aloha',
  Invitation: 'invite',
  Prints: 'prints',
} as const;

export const eventProductTypes = {
  'Save the Date': 'save-the-date',
  'Wedding Website': 'designs',
  Invitation: 'invite',
  Prints: 'prints',
} as const;
